import { rsvpNo } from './rsvpNo';
import { rsvpUpdate } from './rsvpUpdate';
import { rsvpWaitlist } from './rsvpWaitlist';
import { rsvpYes } from './rsvpYes';
import { doubleOptIn } from './doubleOptIn';
import { ticketDefault } from './ticketDefault';

export const confirmationsDefaultStructures = {
    'rsvp-yes': rsvpYes,
    'rsvp-no': rsvpNo,
    'rsvp-update': rsvpUpdate,
    'rsvp-waitlist': rsvpWaitlist,
    'double-opt-in': doubleOptIn,
    'ticket-default': ticketDefault,
    'ticket-multi': ticketDefault,
    'ticket-custom': ticketDefault,
};
